module.exports = __webpack_public_path__ + "img/page5.b837d1ee.png";